// KPI hücre notu iş parçacığı — typed wrapper'lar (portal yetki v2 Dalga 3 D3-3; spec §6/§7).
// İki yüz aynı gövdeleri paylaşır: müşteri `/portal/kpi/sets/:setId/notes…` (set erişimi + işletme
// kapsamı sunucuda her istekte yeniden doğrulanır), danışman `/kpi/sets/:setId/notes…`. Yazma
// 30/dk/kullanıcı (429 Türkçe `message`); görünmeyen hücre tek 403 gövdesi. `clientRequestId`
// çift gönderimi tekilleştirir (aynı kimlik → 200 + mevcut satır) — yeniden denemede AYNI id kullanılır.

import type { KpiNoteSummaryCell, KpiValueNoteDto } from "@mahir/shared";
import { api } from "./client";

export type NotesAudience = "portal" | "internal";

/** Thread hücresi — `kpi_values` beşlisinin değer satırı gerektirmeyen hali (dönem: yıllık). */
export interface NoteCellRef {
  metricId: string;
  entityId: string;
  year: number;
}

function base(audience: NotesAudience, setId: string): string {
  return audience === "portal" ? `/portal/kpi/sets/${setId}` : `/kpi/sets/${setId}`;
}

function cellQuery(cell: NoteCellRef): string {
  const q = new URLSearchParams({
    metricId: cell.metricId,
    entityId: cell.entityId,
    year: cell.year.toString(),
  });
  return q.toString();
}

export async function listCellNotes(
  audience: NotesAudience,
  setId: string,
  cell: NoteCellRef,
): Promise<KpiValueNoteDto[]> {
  const res = await api<{ notes: KpiValueNoteDto[] }>(
    `${base(audience, setId)}/notes?${cellQuery(cell)}`,
  );
  return res.notes;
}

export async function createCellNote(
  audience: NotesAudience,
  setId: string,
  cell: NoteCellRef,
  body: string,
  clientRequestId: string,
): Promise<KpiValueNoteDto> {
  const res = await api<{ note: KpiValueNoteDto }>(`${base(audience, setId)}/notes`, {
    method: "POST",
    body: { ...cell, body, clientRequestId },
  });
  return res.note;
}

/** Karşı tarafın mesajlarını "okundu" işaretler (yalnız karşı taraf satırları). */
export async function markCellNotesSeen(
  audience: NotesAudience,
  setId: string,
  cell: NoteCellRef,
): Promise<void> {
  await api(`${base(audience, setId)}/notes/seen`, { method: "POST", body: { ...cell } });
}

/** Görünür yıllar için hücre özetleri (sayı + okunmamış + son yazar tarafı). */
export async function fetchNoteSummary(
  audience: NotesAudience,
  setId: string,
  years: number[],
): Promise<KpiNoteSummaryCell[]> {
  if (years.length === 0) return [];
  const res = await api<{ cells: KpiNoteSummaryCell[] }>(
    `${base(audience, setId)}/note-summary?years=${years.join(",")}`,
  );
  return res.cells;
}
